import { render, staticRenderFns } from "./DashboardGenericCard.vue?vue&type=template&id=75878e4e&"
import script from "./DashboardGenericCard.vue?vue&type=script&lang=js&"
export * from "./DashboardGenericCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports